interface RadioProps {
  checked: boolean;
  'data-testid'?: string;
  disabled?: boolean;
}

const Radio = ({
  checked,
  'data-testid': dataTestId,
  disabled = false,
}: RadioProps) => {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={checked}
      data-state={checked ? 'checked' : 'unchecked'}
      className="group relative flex h-5 w-5 items-center justify-center outline-none"
      data-testid={dataTestId || 'radio-button'}
      disabled={disabled}
    >
      <div className="group-hover:shadow-borders-strong-with-shadow group-data-[state=checked]:shadow-borders-interactive bg-ui-bg-base shadow-borders-base group-focus:!shadow-borders-interactive-with-focus group-disabled:!bg-ui-bg-disabled group-disabled:!shadow-borders-base group-data-[state=checked]:bg-ui-bg-interactive flex h-[14px] w-[14px] items-center justify-center rounded-full transition-all">
        {checked && (
          <span
            data-state="checked"
            className="group flex items-center justify-center"
          >
            <div className="bg-ui-bg-base shadow-details-contrast-on-bg-interactive group-disabled:bg-ui-fg-disabled h-1.5 w-1.5 rounded-full group-disabled:shadow-none"></div>
          </span>
        )}
      </div>
    </button>
  );
};

export default Radio;
